import { createFeatureSelector, createSelector } from "@ngrx/store";
import { coefficientSetFeatureKey } from "./coefficient-set.reducer";

export const selectCoefficientSetState = createFeatureSelector(coefficientSetFeatureKey);

export const selectCoefficientSet = createSelector(
  selectCoefficientSetState,
  (state: any) => state
); 
